import { Code as ConnectCode, ConnectError } from '@connectrpc/connect';
/** Tenant id the shared, read-only government organization reference is stored under. */ export const SYSTEM_TENANT_ID = '_system';
/** The real hierarchy is a handful of levels deep; the cap only guards a corrupt or cyclic catalog. */ export const MAX_ANCESTOR_DEPTH = 12;
export const isSystemOrg = (o)=>o.companyId === SYSTEM_TENANT_ID;
/**
 * Ancestors of `org`, root first, excluding `org` itself. The walk stops at a
 * missing parent, a revisited id, or MAX_ANCESTOR_DEPTH, so a cycle cannot hang the panel.
 */ export function ancestorChain(org, byId) {
    const chain = [];
    const seen = new Set([
        org.id
    ]);
    let parent = org.parentId ? byId.get(org.parentId) : undefined;
    while(parent && !seen.has(parent.id) && chain.length < MAX_ANCESTOR_DEPTH){
        seen.add(parent.id);
        chain.unshift(parent);
        parent = parent.parentId ? byId.get(parent.parentId) : undefined;
    }
    return chain;
}
export function childrenOf(orgs, parentId) {
    return orgs.filter((o)=>o.parentId === parentId).sort((a, b)=>a.name.localeCompare(b.name));
}
/** User-readable text for the codes the government-organization writes refuse with. */ export function govOrgErrorMessage(err) {
    const e = ConnectError.from(err);
    switch(e.code){
        case ConnectCode.PermissionDenied:
            return 'This organization is a shared reference and cannot be changed. Add a suborganization under it instead.';
        case ConnectCode.AlreadyExists:
            return 'Another organization in your registry already uses that office code. Use a different code or leave it blank.';
        case ConnectCode.InvalidArgument:
            return `That change is not allowed: ${e.rawMessage || 'an organization cannot be its own parent or sit beneath its own descendant.'}`;
        case ConnectCode.NotFound:
            return 'That organization no longer exists or belongs to another tenant. Refresh and try again.';
        default:
            return e.rawMessage || 'The organization could not be saved. Try again.';
    }
}
